<script setup>
/**
 * Renders a form field's error message.
 *
 * Vuetify's built-in `:error-messages` slot does not render in this app
 * (Vue 2 -> 3 migration artifact), so field errors are rendered manually.
 * This is the single source of truth for that markup + styling.
 */
defineProps({
  error: { type: String, default: '' },
  // id so the associated control can point at this via aria-describedby.
  id: { type: String, default: undefined }
});
</script>

<template>
  <div v-if="error" :id="id" class="field-error" role="alert">
    <i class="fas fa-exclamation-triangle fa-lg"></i>
    <span>{{ error }}</span>
  </div>
</template>

<style scoped>
.field-error {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  color: #cc2f2f;
  font-size: 12px;
  line-height: 18px;
  margin-top: 4px;
}

.field-error i {
  display: inline-block;
  line-height: 1;
  flex-shrink: 0;
}

.field-error span {
  display: inline-block;
  line-height: 18px;
}

.field-error.align-start {
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
}

.field-error.align-start i {
  margin-top: 2px;
}
</style>
